(function () {
  'use strict';

  // ===== Cart helpers =====
  function getCartElement() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  // Pre-clear empty state so the first add transitions cleanly
  function clearEmptyState() {
    var drawer = getCartElement();
    if (!drawer) return;
    drawer.classList.remove('is-empty');
    var inner = drawer.querySelector('.drawer__inner');
    if (inner) inner.classList.remove('is-empty');
    var emptyView = drawer.querySelector('.drawer__inner-empty');
    if (emptyView) emptyView.setAttribute('hidden', '');
  }

  function getSectionsList() {
    var drawer = getCartElement();
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      try {
        var list = drawer.getSectionsToRender() || [];
        var ids = list.map(function (s) { return s.id; }).filter(Boolean);
        if (ids.length) return ids.join(',');
      } catch (e) {}
    }
    return 'cart-drawer,cart-icon-bubble,cart-live-region-text';
  }

  // Use Dawn's native pattern: FormData + matching headers + renderContents
  function addToCartViaDawnPattern(variantId, quantity) {
    var formData = new FormData();
    formData.append('id', String(variantId));
    formData.append('quantity', String(quantity));
    formData.append('sections', getSectionsList());
    formData.append('sections_url', window.location.pathname);

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/javascript'
      },
      body: formData
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  // Hand response to theme's own cart renderer (which updates sections + opens drawer)
  function renderAndOpen(response) {
    var drawer = getCartElement();
    if (!drawer) {
      window.location.href = '/cart';
      return false;
    }
    // Important: clear the is-empty state BEFORE renderContents so first add works
    clearEmptyState();
    if (typeof drawer.renderContents === 'function') {
      try {
        drawer.renderContents(response);
        return true;
      } catch (e) {
        console.error('SML renderContents threw, falling back', e);
      }
    }
    // Fallback: click cart icon to trigger theme's own open + refresh
    var cartTrigger = document.querySelector('#cart-icon-bubble, [data-cart-drawer-toggle], summary[aria-controls*="cart"], .header__cart-link');
    if (cartTrigger) {
      cartTrigger.click();
      return true;
    }
    window.location.href = '/cart';
    return false;
  }

  // ===== Countdown =====
  function startCountdown(root) {
    var el = root.querySelector('[data-sml-countdown]');
    if (!el) return;
    var deadline = el.getAttribute('data-deadline');
    if (!deadline) return;
    var target = new Date(deadline).getTime();
    if (isNaN(target)) return;
    var dayEl = el.querySelector('[data-d]');
    var hrsEl = el.querySelector('[data-h]');
    var minEl = el.querySelector('[data-m]');
    var secEl = el.querySelector('[data-s]');
    var headEl = root.querySelector('[data-sml-countdown-head]');
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) {
        if (dayEl) dayEl.textContent = '00';
        if (hrsEl) hrsEl.textContent = '00';
        if (minEl) minEl.textContent = '00';
        if (secEl) secEl.textContent = '00';
        if (headEl) headEl.textContent = 'Father’s Day delivery cut‑off has passed';
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (dayEl) dayEl.textContent = pad(d);
      if (hrsEl) hrsEl.textContent = pad(h);
      if (minEl) minEl.textContent = pad(m);
      if (secEl) secEl.textContent = pad(s);
      requestAnimationFrame(function () { setTimeout(tick, 1000); });
    }
    tick();
  }

  // ===== B2G1F dynamic offer bar =====
  function setupOfferBar(root, productId) {
    var bar = root.querySelector('[data-sml-offer]');
    if (!bar) return function () {};
    var msgEl = bar.querySelector('[data-sml-offer-msg]');
    var iconEl = bar.querySelector('[data-sml-offer-icon]');
    var buy = root.querySelector('[data-sml-buy]');
    var currency = (buy && buy.getAttribute('data-currency')) || 'GBP';

    var msgs = {
      'default':  bar.getAttribute('data-msg-default')  || 'Buy 2 get 1 FREE',
      'close':    bar.getAttribute('data-msg-close')    || 'Add 1 more kit to get 1 FREE',
      'action':   bar.getAttribute('data-msg-action')   || 'Claim your free kit',
      'unlocked': bar.getAttribute('data-msg-unlocked') || 'Free kit added — you saved {saved}',
      'progress': bar.getAttribute('data-msg-progress') || 'Add {n} more for another free kit'
    };
    var icons = { 'default': '🎁', 'close': '🎁', 'action': '🎁', 'unlocked': '🎉', 'progress': '🎁' };
    var stateClasses = ['state-default', 'state-close', 'state-action', 'state-unlocked', 'state-progress'];

    function formatMoney(pence) {
      var n = (pence || 0) / 100;
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(n);
      } catch (e) {
        return (currency === 'GBP' ? '£' : '') + n.toFixed(2);
      }
    }

    function calcSavings(unitPrices) {
      var qty = unitPrices.length;
      var freeKits = Math.floor(qty / 3);
      if (freeKits <= 0) return 0;
      var sorted = unitPrices.slice().sort(function (a, b) { return a - b; });
      var saved = 0;
      for (var i = 0; i < freeKits; i++) saved += sorted[i] || 0;
      return saved;
    }

    var clickQty = { 'default': 3, 'close': 2, 'action': 1 };

    function render(qty, savedPence) {
      var key, msg;
      if (qty <= 0) {
        key = 'default';
        msg = msgs['default'];
      } else if (qty === 1) {
        key = 'close';
        msg = msgs['close'];
      } else if (qty % 3 === 2) {
        key = 'action';
        msg = msgs['action'];
      } else if (qty % 3 === 0) {
        key = 'unlocked';
        msg = msgs['unlocked'].replace('{saved}', formatMoney(savedPence));
      } else {
        key = 'progress';
        var more = 3 - (qty % 3);
        msg = msgs['progress'].replace('{n}', more);
      }
      stateClasses.forEach(function (c) { bar.classList.remove(c); });
      bar.classList.add('state-' + key);
      bar.setAttribute('data-cart-state', key);
      var clickable = !!clickQty[key];
      bar.setAttribute('aria-disabled', clickable ? 'false' : 'true');
      bar.classList.toggle('is-clickable', clickable);
      if (msgEl) msgEl.textContent = msg;
      if (iconEl) iconEl.textContent = icons[key];
      if (buy && typeof buy._smlUpdateCta === 'function') buy._smlUpdateCta();
    }

    bar.addEventListener('click', function () {
      var state = bar.getAttribute('data-cart-state') || 'default';
      var qtyToAdd = clickQty[state];
      if (!qtyToAdd) return;
      var current = (buy && typeof buy._smlGetCurrent === 'function') ? buy._smlGetCurrent() : null;
      if (!current || !current.available) return;
      if (bar.classList.contains('is-loading')) return;
      bar.classList.add('is-loading');
      var originalMsg = msgEl ? msgEl.textContent : '';
      if (msgEl) msgEl.textContent = 'Adding ' + qtyToAdd + '…';

      addToCartViaDawnPattern(current.id, qtyToAdd)
        .then(function (data) {
          showToast('Added ' + qtyToAdd + ' × ' + current.title + ' — Buy 2 Get 1 FREE applied');
          renderAndOpen(data);
          if (window.PUB_SUB_EVENTS && window.publish) {
            try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'sml-offer-bar', cartData: data }); } catch (e) {}
          }
          refresh();
          setTimeout(function () { bar.classList.remove('is-loading'); }, 600);
        })
        .catch(function (err) {
          console.error('SML offer-bar add error', err);
          if (msgEl) msgEl.textContent = originalMsg;
          bar.classList.remove('is-loading');
          showToast('Could not add. Please try again.');
        });
    });

    function refresh() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var unitPrices = [];
          (cart.items || []).forEach(function (item) {
            if (!productId || String(item.product_id) === String(productId)) {
              var q = item.quantity || 0;
              for (var i = 0; i < q; i++) unitPrices.push(item.price || 0);
            }
          });
          var saved = calcSavings(unitPrices);
          render(unitPrices.length, saved);
        })
        .catch(function () { });
    }
    refresh();
    return refresh;
  }

  // ===== Buy box =====
  function initBuyBox(root) {
    var buy = root.querySelector('[data-sml-buy]');
    if (!buy) return;
    var productId = buy.getAttribute('data-product-id');
    var refreshOffer = setupOfferBar(root, productId);

    var variantById = {};
    root.querySelectorAll('[data-sml-variant]').forEach(function (el) {
      var v = el.dataset;
      variantById[v.smlVariant] = {
        id: v.smlVariant,
        title: v.title,
        price: v.price,
        priceFormatted: v.priceFormatted,
        compareAt: v.compareAt,
        compareAtFormatted: v.compareAtFormatted,
        available: v.available === 'true'
      };
    });

    var defaultId = buy.getAttribute('data-default-variant');
    var current = variantById[defaultId] || null;

    var labelB = buy.querySelector('[data-sml-current-label]');
    var ctaPrice = buy.querySelector('[data-sml-cta-price]');
    var cta = buy.querySelector('[data-sml-cta]');
    var chips = buy.querySelectorAll('[data-sml-variant-chip]');
    var qtyDisplay = buy.querySelector('[data-sml-qty]');
    var qtyMinus = buy.querySelector('[data-sml-qty-minus]');
    var qtyPlus = buy.querySelector('[data-sml-qty-plus]');
    var qty = 1;

    function render() {
      if (!current) return;
      var isDefault = current.id === defaultId;
      if (labelB) labelB.textContent = current.title + (isDefault ? ' · MOST POPULAR' : '');
      chips.forEach(function (c) {
        var on = c.dataset.smlVariantChip === current.id;
        c.classList.toggle('sel', on);
        c.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      updateCta();
    }

    function updateCta() {
      if (!current || !cta) return;
      var ctaTextEl = cta.querySelector('[data-sml-cta-text]');
      var bar = root.querySelector('[data-sml-offer]');
      var isFreeMode = bar && bar.getAttribute('data-cart-state') === 'action' && current.available;

      cta.disabled = !current.available;
      cta.classList.toggle('is-free-mode', !!isFreeMode);

      if (!current.available) {
        if (ctaTextEl) ctaTextEl.textContent = 'Sold out';
        if (ctaPrice) ctaPrice.textContent = current.priceFormatted;
      } else if (isFreeMode) {
        if (ctaTextEl) ctaTextEl.textContent = 'Add FREE kit';
        if (ctaPrice) ctaPrice.innerHTML = '<s>' + current.priceFormatted + '</s> FREE';
      } else {
        if (ctaTextEl) ctaTextEl.textContent = 'Add to basket';
        if (ctaPrice) ctaPrice.textContent = current.priceFormatted;
      }
    }

    buy._smlUpdateCta = updateCta;
    buy._smlGetCurrent = function () { return current; };

    function selectVariant(id) {
      var v = variantById[id];
      if (!v) return;
      current = v;
      render();
      syncGalleryToVariant(id);
    }

    var heroImage = root.querySelector('[data-sml-hero-image]');
    var thumbs = root.querySelectorAll('[data-sml-thumbs] .thumb');
    var variantToImage = {};
    chips.forEach(function (c) {
      var url = c.getAttribute('data-variant-image');
      if (url) variantToImage[c.dataset.smlVariantChip] = url;
    });

    function setHeroImage(url, activeThumb) {
      if (heroImage && url && heroImage.src !== url) {
        heroImage.classList.add('is-swapping');
        setTimeout(function () {
          heroImage.src = url;
          heroImage.classList.remove('is-swapping');
        }, 120);
      }
      thumbs.forEach(function (t) {
        var on = t === activeThumb;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    function syncGalleryToVariant(variantId) {
      var url = variantToImage[variantId];
      var thumb = root.querySelector('[data-thumb-variant="' + variantId + '"]');
      if (!thumb) {
        thumb = root.querySelector('[data-thumb-variant="all"]');
        if (thumb && !url) url = thumb.getAttribute('data-thumb-image');
      } else if (!url) {
        url = thumb.getAttribute('data-thumb-image');
      }
      if (url) setHeroImage(url, thumb);
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var vid = t.getAttribute('data-thumb-variant');
        var url = t.getAttribute('data-thumb-image');
        if (vid && vid !== 'all' && variantById[vid]) {
          selectVariant(vid);
        } else {
          if (defaultId) selectVariant(defaultId);
          setHeroImage(url, t);
        }
      });
    });

    chips.forEach(function (c) {
      c.addEventListener('click', function () { selectVariant(c.dataset.smlVariantChip); });
    });
    if (qtyMinus) qtyMinus.addEventListener('click', function () {
      qty = Math.max(1, qty - 1);
      if (qtyDisplay) qtyDisplay.textContent = qty;
    });
    if (qtyPlus) qtyPlus.addEventListener('click', function () {
      qty = Math.min(99, qty + 1);
      if (qtyDisplay) qtyDisplay.textContent = qty;
    });

    if (cta) cta.addEventListener('click', function () {
      if (!current || !current.available) return;
      cta.classList.add('is-loading');
      var ctaTextEl = cta.querySelector('[data-sml-cta-text]');
      var wasFreeMode = cta.classList.contains('is-free-mode');
      if (ctaTextEl) ctaTextEl.textContent = 'Adding…';

      addToCartViaDawnPattern(current.id, qty)
        .then(function (data) {
          if (ctaTextEl) ctaTextEl.textContent = wasFreeMode ? '🎉 Free kit added!' : 'Added ✓';
          showToast((wasFreeMode ? '🎉 Free kit added! • ' : 'Added to basket • ') + current.title);
          if (refreshOffer) refreshOffer();
          renderAndOpen(data);
          if (window.PUB_SUB_EVENTS && window.publish) {
            try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'sml-buy-box', cartData: data, productVariantId: current.id }); } catch (e) {}
          }
          setTimeout(function () {
            cta.classList.remove('is-loading');
            updateCta();
          }, 1400);
        })
        .catch(function (err) {
          console.error('SML add error', err);
          cta.classList.remove('is-loading');
          updateCta();
          showToast('Could not add. Please try again.');
        });
    });

    render();
  }

  function showToast(msg) {
    var t = document.querySelector('.sml-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'sml-toast';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    requestAnimationFrame(function () { t.classList.add('show'); });
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.classList.remove('show'); }, 2400);
  }

  // ===== Scroll-to-buy CTAs =====
  function initScrollToBuy(root) {
    var buy = root.querySelector('[data-sml-buy]');
    if (!buy) return;
    root.querySelectorAll('[data-sml-scroll-to-buy]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        try {
          buy.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' });
        } catch (err) {
          buy.scrollIntoView();
        }
        buy.classList.add('sml-flash');
        setTimeout(function () { buy.classList.remove('sml-flash'); }, 1400);
      });
    });
  }

  // ===== Init =====
  function init() {
    document.querySelectorAll('.sml').forEach(function (root) {
      startCountdown(root);
      initBuyBox(root);
      initScrollToBuy(root);
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
